import { atom } from "jotai";

import type { Props } from "scmp-app/components/advertisement/ad-slots/ad-slot";

export type AdSlotState = {
  desktop: HeaderAdSlotSpec | null;
  manualRefreshCount?: number;
  mobile: HeaderAdSlotSpec | null;
};

type HeaderAdSlotSpec = Pick<Props, "adUnit" | "autoRefreshOptions" | "targeting" | "zone"> & {
  sizes?: googletag.GeneralSize;
};

export const defaultTopBannerAdSlotStateAtom: AdSlotState = {
  desktop: null,
  mobile: null,
};

export const topBannerAdSlotAtom = atom<AdSlotState>(defaultTopBannerAdSlotStateAtom);
